<input
  matInput
  [matAutocomplete]="auto"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [placeholder]="to.placeholder"
  [errorStateMatcher]="errorStateMatcher"
/>
<mat-autocomplete #auto="matAutocomplete">
  <ng-container *ngIf="results$ | formlySelectOptions:field | async as selectOptions">
    <mat-option
      *ngFor="let item of selectOptions; trackBy: trackOption; let index = index;"
      [value]="item.value"
      (onSelectionChange)="onOptionSelected(index)"
    >
      {{ item.label }}
    </mat-option>
  </ng-container>
</mat-autocomplete>
